import { toast } from "sonner";

interface AchievementGrantResult {
  earned?: boolean;
  already_earned?: boolean;
  xp_gained?: number;
  credits_gained?: number;
  /** The achievement title returned by the grant_achievement RPC */
  achievement?: string;
  /** Set when the XP gain caused a level-up (returned by the RPC if supported) */
  leveled_up?: boolean;
  new_level?: number;
  error?: string;
}

export function showAchievementToast(result: AchievementGrantResult | null | undefined): void {
  if (!result?.earned) return;

  // Show achievement title when available (RPC returns it as 'achievement')
  const title = result.achievement
    ? `🏆 ${result.achievement}`
    : "🏆 Achievement unlocked!";

  const parts: string[] = [];
  if (result.xp_gained && result.xp_gained > 0) parts.push(`+${result.xp_gained} XP`);
  if (result.credits_gained && Number(result.credits_gained) > 0) parts.push(`+${result.credits_gained} credits`);

  toast.success(title, {
    description: parts.length > 0 ? parts.join(" · ") : "Keep adventuring!",
    duration: 4000,
  });

  // Level-up celebration toast (separate so it draws attention)
  if (result.leveled_up && result.new_level) {
    toast.success(`⬆️ Level ${result.new_level}!`, {
      description: "You've reached a new level. Check your profile for rewards.",
      duration: 5000,
    });
  }
}
